import script from "./moveModal.vue?vue&type=script&setup=true&lang=js"
export * from "./moveModal.vue?vue&type=script&setup=true&lang=js"

import "./moveModal.vue?vue&type=style&index=0&id=ac327bba&scoped=true&lang=css"
import "./moveModal.vue?vue&type=style&index=1&id=ac327bba&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac327bba"]])

export default __exports__